import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  api_pricing_service_provider: '',
  api_pricing: false,
  hidden: false,
  price: 0,
  provider_price_list_id: undefined,
  quantity: 0,
  service_product_id: undefined,
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice },
  { key: 'provider_price_list_id' },
  { key: 'quantity' },
  { key: 'service_product_id' },
]

export default state
